<template lang="pug">
.curso-main-container.introduccion
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span
          i.fas.fa-info
      h1 Introducción
    

    .col-xl-8.m-auto.col-lg-10
      p.fw-bold.text-center(data-aos="zoom-in") Estimado aprendiz, bienvenido al componente formativo “Conectividad de las redes en las organizaciones”.  #[br] Aproxímese a su contenido y alcance, a través del siguiente video introductorio.
    
    figure.mt-4(data-aos="zoom-in-up")
      .video
        iframe(width="560" height="315" src="https://www.youtube.com/embed/ReZ36xn85F0?si=jUlJxi6TkG0sNRN4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
    
</template>

<script>
export default {
  name: 'Introduccion',
  data: () => ({
    // variables de vue
  }),
}
</script>

<style lang="sass"></style>
